import { ReactNode, useState, useEffect, useCallback } from 'react'

interface CacheMeasurerProps {
  children: ReactNode | ReactNode[]
  search: string
  cache: any
}

interface CacheMeasurerHook {
  height: number
}

/**
 * Set the height for each row item.
 * @param props
 * @param props.children Item
 * @param props.search Search text from text input.
 */
export const useCacheMeasurer = ({
  children,
  search,
  cache,
}: CacheMeasurerProps): CacheMeasurerHook => {
  const [height, setHeight] = useState(300)
  const isChildrenArray = Array.isArray(children)

  const calculateHeight = useCallback(() => {
    const addCacheHeight = (mem, _e, i) => mem + cache.getHeight(i)
    const smallHeight = isChildrenArray && children.length ? children.reduce(addCacheHeight, 0) : 33
    const newHeight = isChildrenArray && children.length > 9 ? 300 : Math.min(300, smallHeight)
    if (newHeight === height) return

    setHeight(newHeight)
  }, [children])

  useEffect(() => {
    calculateHeight()
  }, [cache])

  useEffect(() => {
    cache.clearAll()
  }, [search])

  return {
    height,
  }
}
